import React from "react";
import { connect } from "react-redux";
import CalculatedPayment from "Shared/CalculatedPayment";
import DealerOfferPayment from "src/components/DealerOfferPayment";
import { ApplicationStore } from "src/store";
import { hasDealerOfferByVin } from "src/store/selectors/dealerOffer";
import { getPayments, getSelectedPaymentType } from "src/store/selectors/vehicles";
import { VehiclePayments } from "Types/api/VehiclePayments";
import "./SidebarPayment.scss";

interface Props {
    vin: string;
}

const SidebarPayment = ({
    account,
    hasDealerOffer,
    payments,
    paymentType,
    vin,
}: Props & ReturnType<typeof mapStateToProps>) => {
    if (hasDealerOffer) {
        return (
            <div className="SidebarPayment">
                <DealerOfferPayment vin={vin} />
            </div>
        );
    }

    return (
        <div className="SidebarPayment">
            <CalculatedPayment
                account={account}
                phoneNumber={account.phone!}
                payments={payments}
                selectedPaymentIndex={paymentType!}
                vin={vin}
                className="SidebarPayment__price"
                inGarage={true}
            />
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin }: Props) => {
    if (hasDealerOfferByVin(state, vin)) {
        return {
            account: state.account,
            hasDealerOffer: true,
            payments: (undefined as unknown) as VehiclePayments,
            paymentType: undefined,
        };
    }

    return {
        account: state.account,
        hasDealerOffer: false,
        payments: getPayments(state, vin),
        paymentType: getSelectedPaymentType(state, vin),
    };
};

export default connect(mapStateToProps)(SidebarPayment);
